import { Box, Button, DropdownMenu } from '@betterment/samba-react';

import { AddCashOptions } from './AddCashOptions';

import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import {
  OtherTransactionOptions,
  TransactionOptionsProps,
} from '../../../../Shared/components/transaction-buttons/TransactionButtons';
import { EnvelopeAccountTransactionOptionsQuery } from '../graphql/envelopeAccountTransactionOptions.generated';

type DirectTradingAccount = NarrowTypename<EnvelopeAccountTransactionOptionsQuery['account'], 'DirectTradingAccount'>;

type Props = TransactionOptionsProps & {
  account: DirectTradingAccount;
};

export const ManageCashButton: React.FC<Props> = ({ account, transactionOptions, subAccounts }) => {
  const { totalBalance } = account.cashBalances;

  return (
    <Box>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild={true}>
          <Button variant="textPrimary">{totalBalance.cents > 0 ? 'Manage' : 'Add cash'}</Button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end" side="bottom">
          <AddCashOptions account={account} />
          <OtherTransactionOptions transactionOptions={transactionOptions} subAccounts={subAccounts} isCompact={true} />
        </DropdownMenu.Content>
      </DropdownMenu>
    </Box>
  );
};
